import SuperTokens, { SuperTokensWrapper } from 'supertokens-auth-react'
import { Provider } from 'react-redux'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { canHandleRoute, getRoutingComponent } from 'supertokens-auth-react/ui'
import { EmailPasswordPreBuiltUI } from 'supertokens-auth-react/recipe/emailpassword/prebuiltui'
import { EmailVerificationPreBuiltUI } from 'supertokens-auth-react/recipe/emailverification/prebuiltui'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import ThemeCustomization from './themes'
import Locales from './components/ui/Locales'
import OrderPreviews from './views/OrderPreviews'
import VacancyPage from './views/Vacancy'
import ApplicationPage from './views/Application'
import { ResetPassword, SignInSignUp } from './views/Auth'
import { ToastProvider } from './contexts/ToastContext'
import { PAGE } from './constants'
import { ConfigProvider } from './contexts/ConfigContext'
import { AppChilds } from './AppChilds'
import { BASE_PATH, SuperTokensConfig } from './config'
import { store } from './store/store'
import './App.scss'

SuperTokens.init(SuperTokensConfig)

function App() {
  if (window.location.pathname.startsWith('/auth/reset-password')) {
    return <ResetPassword />
  }
  if (canHandleRoute([EmailPasswordPreBuiltUI])) {
    return <SignInSignUp />
  }
  if (canHandleRoute([EmailVerificationPreBuiltUI])) {
    return getRoutingComponent([EmailVerificationPreBuiltUI])
  }

  return (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Locales>
          <ConfigProvider>
            <ToastProvider>
              <BrowserRouter basename={BASE_PATH}>
                <ThemeCustomization>
                  <Routes>
                    {/* Public routes */}
                    <Route path={`${PAGE.VACANCIES.PATH}/:id`} element={<VacancyPage />} />
                    <Route path={PAGE.APPLICATION.PATH} element={<ApplicationPage />} />
                    <Route path={PAGE.ORDER_PREVIEWS.PATH} element={<OrderPreviews />} />
                    <Route path="/reset-password" element={<ResetPassword />} />

                    {/* Protected routes */}
                    <Route
                      path="/*"
                      element={
                        <SuperTokensWrapper>
                          <AppChilds />
                        </SuperTokensWrapper>
                      }
                    />
                  </Routes>
                </ThemeCustomization>
              </BrowserRouter>
            </ToastProvider>
          </ConfigProvider>
        </Locales>
      </LocalizationProvider>
    </Provider>
  )
}

export default App
